const Helper = {

	install(Vue, options){

		 Vue.prototype.$randUniqueID = function(){
	        return "_"+(Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase();
	      }

		Vue.prototype.$appInitRequests = function(){
			return new Promise(function(resolve, reject){
				//var name_surname_call = _app.$store._actions.nameSurnameCall[0]();
				

				Promise.all([
					//name_surname_call
				]).then(function(){
					console.log("istekler tamamlandı!");
					resolve();
				}).catch(function(error){
					console.log("error", error);
					reject();
				})

			})
		}

		Vue.prototype.$getDiffIntervalMoneyboxUnload = (moneybox) => {
			if(!moneybox.last_unload_date == '0001-01-01T00:00:00Z'){return 'red'}

	        let m_ustate_c = moneybox.last_unload_date
	        let m_unload_interval = moneybox.unload_interval
	        
	        if(m_unload_interval){

	          let now = new Date();
	          let ms_difference = now.getTime() - new Date(m_ustate_c).getTime();
	          let diff_day = Math.floor(ms_difference / (1000 * 60 * 60 * 24));

	          let diff_total = (m_unload_interval - diff_day)

	          if( diff_total <= 1){

	            return 'red'
	          }else if(diff_total <=4){

	            return 'yellow'
	          }else{

	            return 'green'
	          }
	        }        
	        return 'yellow'
		}
		Vue.prototype.$timeZoneConverterGlobal = (date) => {
			date = new Date(date)
			if(_app.isIsoDate(date)){
	          return new Date(date);
	        }else{
	          return (moment(date).tz("Etc/UTC").tz(Intl.DateTimeFormat().resolvedOptions().timeZone)._d);
	        }
		}
		Vue.prototype.$isIsoDate = function(str) {
	      if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str)) return false;
	      var d = new Date(str); 
	      return d.toISOString()===str;
	    }
	}

}

export default Helper;